import api from './api';

export const createComputerGame = (displayName = null) => {
  const body = displayName ? { displayName } : {};
  return api.post('/api/game/create-computer', body);
};

export const getGame = (gameId) => {
  return api.get(`/api/game/${gameId}`);
};

export const getActiveGames = () => {
  return api.get('/api/game/active');
};

export const makeMove = (gameId, row, col) => {
  return api.post(`/api/game/${gameId}/move`, { row, col });
};

export const abandonGame = (gameId) => {
  return api.post(`/api/game/${gameId}/abandon`);
};

export const sendInvite = (inviteeUsername) => {
  return api.post(`/api/game/invite/send/${inviteeUsername}`);
};

export const getPendingInvites = () => {
  return api.get('/api/game/invite/pending');
};

export const getSentInvites = () => {
  return api.get('/api/game/invite/sent');
};

export const acceptInvite = (inviteId) => {
  return api.post(`/api/game/invite/${inviteId}/accept`);
};

export const declineInvite = (inviteId) => {
  return api.post(`/api/game/invite/${inviteId}/decline`);
};

export const cancelInvite = (inviteId) => {
  return api.post(`/api/game/invite/${inviteId}/cancel`);
};

// Mosquito game score APIs
export const saveMosquitoScore = (score, misses) => {
  return api.post('/api/game/mosquito/score', { score, misses });
};

export const getMosquitoLeaderboard = () => {
  return api.get('/api/game/mosquito/leaderboard');
};

export const getMyMosquitoScores = () => {
  return api.get('/api/game/mosquito/my-scores');
};

export const getMyMosquitoHighScore = () => {
  return api.get('/api/game/mosquito/my-high-score');
};

// Dragon game score APIs
export const saveDragonScore = (score, diamonds, collisions) => {
  return api.post('/api/game/dragon/score', { score, diamonds, collisions });
};

export const getDragonLeaderboard = () => {
  return api.get('/api/game/dragon/leaderboard');
};

export const getMyDragonScores = () => {
  return api.get('/api/game/dragon/my-scores');
};

export const getMyDragonHighScore = () => {
  return api.get('/api/game/dragon/my-high-score');
};

